import React from "react";
import get from "lodash/get";
import omit from "lodash/omit";
import { useTranslation } from "react-i18next";
import Modal from "../modal";
import ModalFooter from "./ModalFooter";
import { PRIMARIES } from "../../constants";
import { useRillContext } from "../../rill/RillReact/share/base";

/**
 * Renders one item of secondary exercises
 * @param index the index of the element. Must be unique
 * @param name the name of the input
 * @param value the value of the input
 * @param label the label of the input
 * @param isActive if its's checked or not
 * @returns {JSX}
 */
function renderSecondaryItem(index, name, value, label, isActive) {
  return (
    <div key={index} className="column checkbox" data-col="1/2">
      <label className="checkbox-input">
        <input
          key={isActive}
          type="checkbox"
          name={name}
          value={value}
          defaultChecked={isActive}
        />
        <span className="checkbox"></span>
        <span className="text">{label}</span>
      </label>
    </div>
  );
}

function renderByExercise(
  primaryExercise,
  allSecondaries,
  selectedSecondaries
) {
  if (!allSecondaries[primaryExercise]) {
    return;
  }
  return allSecondaries[primaryExercise].map((secondary, index) => {
    let isActive = false;
    if (selectedSecondaries && selectedSecondaries[primaryExercise]) {
      isActive = selectedSecondaries[primaryExercise].find(
        (sel) => sel.movement === secondary.movement
      );
    }
    return renderSecondaryItem(
      `${primaryExercise}-${index}`,
      `secondaries[${primaryExercise}][]`,
      JSON.stringify(secondary),
      secondary.movement,
      isActive
    );
  });
}

class ExerciseAccordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };

    this.toggleExpand = this.toggleExpand.bind(this);
  }
  toggleExpand() {
    this.setState({ expanded: !this.state.expanded });
  }
  render() {
    const { allSecondaries, selectedSecondaries, primaryExercise } = this.props;
    const { expanded } = this.state;

    return (
      <div className="primary-exercise-wrapper" key={primaryExercise}>
        <div className="column title" data-col="1/1">
          <h3
            onClick={this.toggleExpand}
            className={`${primaryExercise} dropdown${
              expanded ? " expanded" : ""
            }`}
          >
            {primaryExercise}{" "}
          </h3>
        </div>
        <div style={{ display: expanded ? "block" : "none" }}>
          {renderByExercise(
            primaryExercise,
            allSecondaries,
            selectedSecondaries
          )}
        </div>
      </div>
    );
  }
}

function FilterExercisesModal(props) {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  const { query } = locals;
  const primary = get(query, "modal.primary") || "all";
  const exerciseLibrary = get(locals, "activeUser.exerciseLibrary") || {};
  const customMetricId = get(locals, "editCustomMetric._id", "");
  const allSecondaries = getAllSecondaries(exerciseLibrary);
  const selectedSecondaries = getSelectedSecondaries();
  const basePath = `/actions/custom-metrics`;

  return (
    <form
      action={`${basePath}/save-secondaries/${primary}/${customMetricId}`}
      method="POST"
      data-noreset
    >
      <Modal width="600px">
        <div className="head border-divider">
          <h2 className="alt">{t("filterExercises.title")}</h2>
        </div>

        <div className="body">
          <div className="Filter-Exercises">
            <div className="checks">
              <a
                className="check"
                href={`${basePath}/check-all-secondaries/${primary}/${customMetricId}`}
              >
                {t("filterExercises.checkAll")}
              </a>
              <a
                className="check"
                href={`${basePath}/uncheck-all-secondaries/${primary}/${customMetricId}`}
              >
                {t("filterExercises.uncheckAll")}
              </a>
            </div>

            <div className="columns">
              {primary === "all"
                ? renderAll(allSecondaries, selectedSecondaries)
                : renderByExercise(
                    primary,
                    allSecondaries,
                    selectedSecondaries
                  )}
            </div>
          </div>
        </div>
        <ModalFooter
          hrefAltButton="/actions/refresh?modal="
          showAltButton={false}
          altButtonText={t("common:cancel")}
          isSubmitButton={true}
          buttonText={t("filterExercises.saveAndView")}
        />
      </Modal>
    </form>
  );

  function renderAll(allSecondaries, selectedSecondaries) {
    return PRIMARIES.map((primaryExercise) => {
      return (
        <ExerciseAccordion
          allSecondaries={allSecondaries}
          selectedSecondaries={selectedSecondaries}
          primaryExercise={primaryExercise}
        />
      );
    });
  }

  /**
   * Returns all secondaries from the exercise library
   * @returns {*|Array} a list of secondary movements
   */
  function getAllSecondaries(exerciseLibrary) {
    return omit(exerciseLibrary, ["assistant"]) || [];
  }

  /**
   * Returns all previously selected secondaries
   * @returns {*}
   */
  function getSelectedSecondaries() {
    return get(locals, "editCustomMetric.filters.secondaries");
  }
}

export default FilterExercisesModal;
